import { React, useEffect, useState, PureComponent } from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Skeleton from '@mui/material/Skeleton';
import { useSnackbar } from 'notistack';
import TokenService from '../../../services/TokenService';

export default function Profits(props) {
    const [isFetching, setIsFetching] = useState(true);
    const [panelData, setPanelData] = useState(null);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    useEffect(() => {
        loadData(); // only called once
    }, []);

    function loadData() {

        TokenService.adminServicePost({ date: '' }, 'Admin_DashboardDailyProfits')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let data = JSON.parse(response.JsonData);
                    let formattedChartData = [];
                    setPanelData(data);
                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Error in Todays Counts', {
                    variant: 'error',
                });
            });

    }

    function buildLoading() {
        return (
            <div>
                <div className='DashboardPanelHeader'>Last 30 days</div>
               
            </div>
        )
    }

    function buildPanel() {
        return (
            <div style={{height:'400px'} }>
                <div className='DashboardPanelHeader'>Last 30 days</div>
                <ResponsiveContainer  style={{ minHeight: '380px' }}>
                    <LineChart
                        width={325}
                        height={380}
                        data={panelData}
                        margin={{
                            top: 5,
                            right: 30,
                            left: 20,
                            bottom: 5,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="Day" />
                        <YAxis />
                        <Tooltip />
                        <Legend />
                        <Line type="monotone" dataKey="TotalPickups" name="Pickups" stroke="#00c144" strokeWidth={3} activeDot={{ r: 8 }} />
                        <Line type="monotone" dataKey="Profit" stroke="#3c3fc4" strokeWidth={3} />
                    </LineChart>
                </ResponsiveContainer>
            </div>
        )
    }
    //Admin_DashboardCountsReport

    return (
        <Card sx={{ minWidth: 300, maxWidth: 400, width: '95%', alignSelf: 'center', margin: '10px' }}>
            <CardContent>
                {isFetching ?
                    buildLoading()
                    :
                    buildPanel()
                }
            </CardContent>
        </Card>
    )
}